import { Mitarbeiter } from '../entities/Mitarbeiter';
import { MitarbeiterAvatar } from '../../../Avatar/MitarbeiterAvatar';

export function MitarbeiterContent({
  mitarbeiter,
}: {
  mitarbeiter: Mitarbeiter;
}) {
  return (
    <div className="flex flex-row items-center gap-4 font-semibold ps-2 pe-4">
      <MitarbeiterAvatar
        vorname={mitarbeiter.vorname}
        nachname={mitarbeiter.nachname}
        extern={mitarbeiter.extern}
        bildUrl={mitarbeiter.imgUrl}
      />
      <span className="truncate md:max-w-40 max-w-28">{`${mitarbeiter.vorname} ${mitarbeiter.nachname}`}</span>
    </div>
  );
}
